import { Canvas } from '@react-three/fiber'
import { Physics } from '@react-three/rapier'
import { Environment } from '@react-three/drei'
import { Perf } from 'r3f-perf'
import { Suspense } from 'react'
import Ecctrl from 'ecctrl'

import Lights from './Lights'
import Map from './Map'
import CharacterModel from './CharacterModel'
import HatenaBlock from './HatenaBlock'

export default function App() {
  return (
    <>
      <Canvas shadows>
        <Perf position="top-left" />
        <Environment background files="/night.hdr" />
        <Lights />
        <Physics timeStep="vary">
          <Suspense fallback={null}>
            <Ecctrl mode="PointToMove">
              <CharacterModel />
            </Ecctrl>
            <Map />
            <HatenaBlock position={[0,2,4]} scale={0.5}  />
          </Suspense>
        </Physics>
      </Canvas>
    </>
  )
}
